import React from "react";
import styles from "../utils/gridStyles.js";
import setHeaderRender from "../../components/app/setHeaderRender";
import dateFormat from 'dateformat';

const setColumns = ({ modalDetail, allowWrite, changeDelay }) => {

    return [
        {
            id: "checkbox",
            visible: true,
            pinned: true,
            width: "54px",
        },
        {
            id: "code",
            field: "code",
            label: "code",
            width: '100px',
            sortable: false,
            resizable: true,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Code', changeDelay, tableManager, column}) )
        },
        {
            id: "2",
            field: "name",
            label: "Name",
            sortable: false,
            resizable: true,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Name', changeDelay, tableManager, column}) )
        },
        {
            id: "3",
            field: "username",
            label: "Username",
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'UserName', changeDelay, tableManager, column}) )
        },
        {
            id: "4",
            field: "email",
            label: "Email",
            width: '300px',
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Email', changeDelay, tableManager, column}) )
        },
        {
            id: "5",
            field: "category",
            label: "Category",
            width: '300px',
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Category', changeDelay, tableManager, column}) )
        },
        {
            id: "6",
            field: "createdAt",
            label: "CreatedAt",
            sortable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (dateFormat(data.createdAt, "dd/mm/yyyy", true)),
        },
        {
            id: "buttons",
            label: "Action",
            width: '110px',
            pinned: true,
            sortable: false,
            resizable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (
                <div style={styles.styleButton.buttonsCellContainer}>

                    {allowWrite
                        ? (<> <button
                            title="Edit"
                            style={styles.styleButton.editButton}
                            onClick={(e) => {
                                e.stopPropagation();
                                modalDetail(data.code, "Edit");
                            }}
                        >
                            {styles.EDIT_SVG}
                        </button> {" - "} </>)
                        : ''
                    }
                    <button
                        title="View"
                        style={styles.styleButton.viewButton}
                        onClick={(e) => {
                            e.stopPropagation();
                            modalDetail(data.code, "View");
                        }}
                    >
                        {styles.VIEW_SVG}
                    </button>
                </div>
            )
        }
    ];
};

export default setColumns;